/** @jsxRuntime classic */
/** @jsx jsx */
import { Box, Link } from '@bottlebooks/gatsby-theme-base';
import { graphql } from 'gatsby';
import React from 'react';
import { jsx } from 'theme-ui';
import useLink from '../../useLink';
import ExhibitorHeader from '../Exhibitor/ExhibitorHeader';
import ProductCard from '../ProductCard/ProductCard';
import ProductsList from '../ProductsList/ProductsList';

export default function ExhibitorProductListPage({ exhibitor }) {
  const link = useLink();
  const products = exhibitor?.products;
  return (
    <React.Fragment>
      <Link to={link.exhibitor(exhibitor)}>
        <Box sx={{ paddingY: 4, paddingX: 3 }}>
          <ExhibitorHeader as="h1" exhibitor={exhibitor} gap={3} />
        </Box>
      </Link>

      <ProductsList count={products?.length} sx={{ flexGrow: 1 }}>
        {products?.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            to={link.product(product)}
            sx={{ marginX: [0, 2], marginY: [0, 2] }}
          />
        ))}
      </ProductsList>
    </React.Fragment>
  );
}

export const fragment = graphql`
  fragment ExhibitorProductListPage on Exhibitor {
    ...BrandBanner
    ...ExhibitorHeader
    exhibitorId
    name
    products {
      productId
      ...ExhibitorPage_Product
    }
    event {
      name
      eventId
    }
  }
`;
